import { useT } from 'apprise-frontend-core/intl/language';
import { useFeedback } from 'apprise-ui/utils/feedback';
import { AllertIcon } from 'apprise-ui/utils/icons';
import { ConnectionOptions, connect } from 'nats.ws';
import { useEffect } from 'react';
import { Fragment } from 'react/jsx-runtime';
import { useBusConnection } from './context';
import { EventsProps } from "./events";

export const EventInitialiser = (props: EventsProps) => {

    const { debug, children } = props

    const t = useT()

    const state = useBusConnection()

    const { showNotification } = useFeedback()


    const initialise = async (mode: 'connect' | 'reconnect') => {


        console.log(mode === 'reconnect' ? 're-connecting to event bus...' : 'connecting to event bus...')

        const connectionProperties: ConnectionOptions = {

            servers: `${window.location.protocol === 'http:' ? 'ws' : 'wss'}://${window.location.host}/event`,
            maxReconnectAttempts: -1,
            waitOnFirstConnect: true
            // , timeout: 10000    default is 200000

        }



        try {

            const connection = await connect(connectionProperties)

            state.set(s => s.connection = connection)

            connection.closed().then(err => {
                if (err)
                    console.log(`error disconnecting from event bus`, err)
            })

            state.set(s => s.connection = connection)

            return connection

        } catch (err) {

            mode === 'reconnect' || console.log(`cannot connect to event bus`, err)

        }


    }


    const initiliseAndMonitor = async () => {

        await initialise('connect')

        let notified = { mode: 'connected' }

        setInterval(async () => {

            const { connection: currentConnection } = state.get()

            if (!currentConnection || currentConnection.isClosed()) {

                debug && console.log("found disconnected: reconnecting attempt...")

                try {

                    const newConnection = await initialise('reconnect')

                    if (newConnection && notified.mode === 'disconnected') {

                        debug && console.log("notifying reconnection is successful..")

                        showNotification(t("bus.connection_established"))
                        notified.mode = 'connected'
                    }

                    if (!newConnection && notified.mode === 'connected') {

                        debug && console.log("notifying reconnection is not successful..")

                        showNotification(t("bus.connection_failure"), { icon: <AllertIcon /> })
                        notified.mode = 'disconnected'
                    }

                }
                catch {

                    debug && console.log("error when attempting to reconnect....")

                }
            }

        }, 5000)

    }

    useEffect(() => {

        initiliseAndMonitor()

        //eslint-disable-next-line
    }, [])


    return <Fragment>{children}</Fragment>


}